/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-12-06",
    versionChannel: "nightly",
    buildDate: "2024-12-06T00:06:59.478Z",
    commitHash: "5a38fb73533241b27e38f7c6deebb92f3cdc87d1",
};
